<main
  class="flex"
  [class.gap-2]="!selectedStore"
  lang="es-HN"
  role="main"
  [class.p-6]="isFloating"
>
  <!-- Store List View -->
  <div
    class="flex flex-col h-full"
    [class.hidden]="selectedStore"
    [class.w-full]="!selectedStore"
  >
    <!-- Back Button (Only for Mobile) -->
    <div
      class="sticky top-0 z-10 bg-white px-4 py-2 xl:hidden"
      [class.hidden]="isFloating"
    >
      <button
        (click)="onClose.emit()"
        class="p-2 rounded-lg transition-colors fs-condensed flex items-center gap-2"
        aria-label="Volver al menú anterior"
        title="Volver al menú anterior"
      >
        <lucide-icon
          [img]="arrowLeftIcon"
          class="size-4 text-appBlack"
          aria-hidden="true"
        ></lucide-icon>
        <span class="text-xs" aria-hidden="true">ATRÁS</span>
      </button>
    </div>

    <!-- Header Title -->
    <header class="flex flex-col items-center" role="banner">
      <!-- Este DIV es para que el titulo y el small se alineen correctamente -->
      <div class="flex flex-col">
        <h2 class="text-2xl font-bold fs-condensed">
          BUSCAR MI TIENDA PREFERIDA
        </h2>
        <small
          class="text-sm text-allasRed underline fs-condensed"
          aria-live="polite"
        >
          {{ viewStores.length }} sucursales disponibles
        </small>
      </div>
    </header>

    <!-- Solo mostrar si ya selecciono una ciudad -->
    @if (selectedCity) {
    <!-- Search Bar -->
    <section
      class="mt-4"
      role="search"
      aria-label="Buscar sucursales"
      [ngClass]="{ 'px-2': !selectedCity, 'px-12': selectedCity }"
    >
      <div class="relative">
        <input
          type="text"
          placeholder="Encuentra tu tienda más cercana"
          [(ngModel)]="searchTerm"
          class="w-full ring-1 ring-appBlack outline-allasRed rounded-md px-4 py-3 fs-condensed placeholder:text-gray-500"
          aria-label="Buscar sucursales por nombre o ubicación"
          title="Buscar sucursales por nombre o ubicación"
          autocomplete="off"
        />
        <lucide-icon
          [img]="searchIcon"
          class="size-5 text-allasRed absolute right-2 top-1/2 transform -translate-y-1/2"
          aria-hidden="true"
        ></lucide-icon>
      </div>
    </section>

    <!-- Separator -->
    <div class="h-px bg-gray-200 my-4"></div>

    <!-- Allow Location And Sort By Distance -->
    <section
      class="flex items-center gap-2 w-full px-6 xl:px-12"
      role="region"
      aria-label="Opciones de ubicación y ordenamiento"
    >
      <button
        class="flex items-center justify-center gap-2 rounded-full px-2 py-1 w-full cursor-pointer fs-condensed"
        [class.opacity-50]="loading"
        [class.cursor-not-allowed]="loading"
        [class.bg-gray-200]="loading"
        [class.text-gray-700]="loading"
        [class.pointer-events-none]="loading"
        [class.bg-allasRed]="!location"
        [class.text-white]="!location"
        [class.bg-appPrimary-500]="location"
        [class.text-white]="location"
        [class.pointer-events-auto]="location"
        (click)="requestLocation()"
        [attr.aria-label]="
          loading
            ? 'Obteniendo ubicación...'
            : location
            ? 'Ordenadas por cercanía'
            : 'Ordenar por cercanía'
        "
        [attr.title]="
          loading
            ? 'Obteniendo ubicación...'
            : location
            ? 'Ordenadas por cercanía'
            : 'Ordenar por cercanía'
        "
        [disabled]="loading"
      >
        <img
          src="/allas-icons/store-new-white.svg"
          alt="Icono de tienda"
          class="size-3 xl:size-4"
          width="20"
          height="20"
          loading="lazy"
        />
        <span class="text-[10px] xl:text-sm text-white" aria-hidden="true">
          {{
            loading
              ? "Obteniendo ubicación..."
              : location
              ? "Ordenadas por cercanía"
              : "Ordenar por distancia"
          }}
        </span>
      </button>
    </section>

    <div class="h-px bg-gray-200 my-4"></div>
    }

    <!-- Vista por Ciudad -->
    @if(!selectedCity) {
    <ng-content *ngTemplateOutlet="storeListByCity"></ng-content>
    } @else {
    <!-- Store List -->
    <ng-content *ngTemplateOutlet="storeList"></ng-content>
    }
  </div>

  <!-- Navegar Button -->
  <ng-template #navegarButton>
    <button
      class="bg-black text-white px-2 py-2 rounded-md fs-condensed flex items-center justify-center gap-2 text-[10px] xl:text-xs w-full"
      aria-label="Navegar a esta sucursal"
      title="Navegar a esta sucursal"
    >
      <span aria-hidden="true">NAVEGAR</span>
    </button>
  </ng-template>

  <!-- Store Details View -->
  <div
    *ngIf="selectedStore"
    class="flex flex-col h-full"
    [class.hidden]="!selectedStore"
    role="region"
    aria-label="Detalles de la sucursal seleccionada"
  >
    <!-- Back Button (Only for Mobile) -->
    <div class="sticky top-0 z-10 bg-white px-4 py-2">
      <button
        (click)="handleBackToList()"
        class="p-2 rounded-lg transition-colors fs-condensed flex items-center gap-2"
        aria-label="Volver a la lista de sucursales"
        title="Volver a la lista de sucursales"
      >
        <lucide-icon
          [img]="arrowLeftIcon"
          class="size-4 text-appBlack"
          aria-hidden="true"
        ></lucide-icon>
        <span class="text-xs" aria-hidden="true">ATRÁS</span>
      </button>
    </div>

    <!-- Header Title -->
    <header class="flex flex-col bg-gray-200 px-4 py-2" role="banner">
      <h1 class="text-2xl font-medium fs-condensed">MI TIENDA</h1>
    </header>

    <span class="flex flex-col xl:flex-row xl:gap-2">
      <!-- Store Info -->
      <div class="px-4 pt-4 w-full xl:w-1/2">
        <!-- Store Image -->
        <div class="mb-4 xl:hidden">
          <img
            [src]="'/images/stores/' + selectedStore.id_image"
            onerror="this.src='/placeholder.svg'"
            [alt]="
              'Imagen de la sucursal ' + selectedStore.address.split(',')[0]
            "
            class="w-full h-64 object-cover"
            width="400"
            height="256"
            loading="lazy"
          />
        </div>

        <!-- Store Details -->
        <h2 class="text-2xl text-appBlack font-medium fs-condensed">
          DETALLES DE SUCURSAL
        </h2>

        <!-- Address -->
        <span class="text-sm text-gray-600 fs-condensed mt-2">
          {{ selectedStore.address }}
        </span>

        <!-- Status And PhoneNumber -->
        <div class="flex flex-col gap-2 mt-2">
          <a
            [href]="'tel:+504' + selectedStore.phone || '2509-7350'"
            class="font-medium fs-condensed text-appPrimary-500 hover:text-allasRed transition-colors duration-150 ease-in-out flex items-center gap-2"
            aria-label="Teléfono de contacto"
          >
            <img
              src="/allas-icons/phone-primary.svg"
              alt="Icono de teléfono"
              class="size-6"
              width="24"
              height="24"
              loading="lazy"
            />
            <span aria-hidden="true">+504 {{ selectedStore.phone }}</span>
          </a>
          <span
            [class]="'text-base' + getStatusClasses(selectedStore.isOpen)"
            [attr.aria-label]="'Estado: ' + getStatusText(selectedStore.isOpen)"
          >
            {{ getStatusText(selectedStore.isOpen) }}
          </span>
        </div>

        <!-- Change Store Button -->
        <button
          class="text-gray-600 fs-condensed underline cursor-pointer mt-2"
          aria-label="Cambiar a otra sucursal"
          title="Cambiar sucursal"
        >
          <span aria-hidden="true">CAMBIAR TIENDA</span>
        </button>

        <!-- Botones de Acción -->
        <div class="gap-2 w-full mt-2 p-4 hidden xl:flex">
          <button
            class="bg-appPrimary-500 text-white px-2 py-2 rounded-md fs-condensed flex items-center justify-center gap-2 text-sm w-1/2"
            (click)="handleStoreSelect(selectedStore)"
            [attr.aria-label]="
              storeService.getSelectedStore()?.id === selectedStore.id
                ? 'Esta sucursal ya está seleccionada'
                : 'Seleccionar esta sucursal'
            "
            [attr.title]="
              storeService.getSelectedStore()?.id === selectedStore.id
                ? 'Esta sucursal ya está seleccionada'
                : 'Seleccionar esta sucursal'
            "
          >
            @if (storeService.getSelectedStore()?.id === selectedStore.id) {
            <!---->
            <lucide-icon
              [img]="checkIcon"
              class="size-4 mr-1"
              aria-hidden="true"
            ></lucide-icon>
            <span aria-hidden="true">SELECCIONADA</span>
            <!---->
            } @else {
            <!---->
            <span aria-hidden="true">SELECCIONAR ESTA TIENDA</span>
            <!---->
            }
          </button>
          <!-- Navegar Button (for Desktop) -->
          <button
            class="hidden xl:flex w-1/2"
            (click)="
              selectedStoreForNavigation = selectedStore;
              navigationPopover.toggle($event)
            "
            aria-label="Abrir opciones de navegación para esta sucursal"
            title="Abrir opciones de navegación"
          >
            <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
          </button>
          <!-- Navegar Button (for Mobile) -->
          <button
            class="xl:hidden w-1/2"
            (click)="openNavigation(selectedStore)"
            aria-label="Abrir opciones de navegación para esta sucursal"
            title="Abrir opciones de navegación"
          >
            <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
          </button>
        </div>
      </div>

      <!-- Store Image -->
      <div class="mb-4 w-1/2 hidden xl:block">
        <img
          [src]="'/images/stores/' + selectedStore.id_image"
          onerror="this.src='/placeholder.svg'"
          [alt]="'Imagen de la sucursal ' + selectedStore.address.split(',')[0]"
          class="w-full h-64 object-cover"
          width="400"
          height="256"
          loading="lazy"
        />
      </div>
    </span>

    <!-- Botones de Acción -->
    <div class="flex gap-2 w-full mt-2 p-4 xl:hidden">
      <button
        class="bg-appPrimary-500 text-white px-2 py-2 rounded-md fs-condensed flex items-center justify-center gap-2 text-sm w-1/2"
        (click)="handleStoreSelect(selectedStore)"
        [attr.aria-label]="
          storeService.getSelectedStore()?.id === selectedStore.id
            ? 'Esta sucursal ya está seleccionada'
            : 'Seleccionar esta sucursal'
        "
        [attr.title]="
          storeService.getSelectedStore()?.id === selectedStore.id
            ? 'Esta sucursal ya está seleccionada'
            : 'Seleccionar esta sucursal'
        "
      >
        @if (storeService.getSelectedStore()?.id === selectedStore.id) {
        <!---->
        <lucide-icon
          [img]="checkIcon"
          class="size-4 mr-1"
          aria-hidden="true"
        ></lucide-icon>
        <span aria-hidden="true">SELECCIONADA</span>
        <!---->
        } @else {
        <!---->
        <span aria-hidden="true">SELECCIONAR ESTA TIENDA</span>
        <!---->
        }
      </button>
      <!-- Navegar Button (for Desktop) -->
      <button
        class="hidden xl:flex w-1/2"
        (click)="
          selectedStoreForNavigation = selectedStore;
          navigationPopover.toggle($event)
        "
        aria-label="Abrir opciones de navegación para esta sucursal"
        title="Abrir opciones de navegación"
      >
        <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
      </button>
      <!-- Navegar Button (for Mobile) -->
      <button
        class="xl:hidden w-1/2"
        (click)="openNavigation(selectedStore)"
        aria-label="Abrir opciones de navegación para esta sucursal"
        title="Abrir opciones de navegación"
      >
        <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
      </button>
    </div>

    <!-- Hours And Services -->
    <div
      class="flex flex-col xl:flex-row gap-2 xl:gap-4 bg-gray-200 p-4"
      role="region"
      aria-label="Información de horarios y servicios"
    >
      <!-- Hours -->
      <div class="flex flex-col gap-2 w-full xl:w-1/2">
        <h3 class="text-lg font-bold text-gray-700 mb-4 fs-condensed">
          LISTA DE HORARIOS
        </h3>

        <div
          class="bg-gray-50 rounded-lg p-4 shadow-md"
          role="list"
          aria-label="Horarios de atención"
        >
          <div class="space-y-3">
            <div
              *ngFor="
                let dayEntry of getDetailedHoursArray(
                  selectedStore.detailedHours || {}
                );
                let i = index
              "
              class="flex justify-between py-2 border-b border-gray-200 last:border-b-0 px-2"
              [class.bg-gray-200]="dayEntry.isToday"
              role="listitem"
              [attr.aria-label]="
                formatDateWithDay(dayEntry.day, getWeekDates()[i]) +
                ', ' +
                dayEntry.hours
              "
            >
              <span
                [class.text-gray-900]="dayEntry.isToday"
                [class.font-bold]="dayEntry.isToday"
                class="text-sm font-medium text-gray-700"
                aria-hidden="true"
              >
                {{ formatDateWithDay(dayEntry.day, getWeekDates()[i]) }}
              </span>
              <span
                [class.text-gray-900]="dayEntry.isToday"
                [class.font-bold]="dayEntry.isToday"
                class="text-sm text-gray-600"
                aria-hidden="true"
              >
                {{ dayEntry.hours }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Services -->
      <div class="flex flex-col gap-2 w-full xl:w-1/2 mt-4 xl:mt-0">
        <h3 class="text-lg font-bold text-gray-700 mb-4 fs-condensed">
          SERVICIOS DE SUCURSAL
        </h3>

        <div
          class="grid grid-cols-3 gap-4"
          role="list"
          aria-label="Servicios disponibles en la sucursal"
        >
          @for (service of selectedStore.services ?? []; track service.name) {
          <article
            class="flex flex-col gap-2 items-center"
            role="listitem"
            [attr.aria-label]="service.name"
          >
            <img
              [src]="service.icon"
              [alt]="'Icono del servicio ' + service.name"
              class="w-auto {{ service.sizeClass || 'h-8' }}"
              width="32"
              height="32"
              loading="lazy"
            />
            <span
              class="text-sm text-center font-medium text-gray-700 fs-condensed"
              aria-hidden="true"
            >
              <p>{{ service.name }}</p>
            </span>
          </article>
          }
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Lista por Ciudad -->
<ng-template #storeListByCity>
  <div
    class="flex flex-col gap-2 w-full items-center"
    [ngClass]="{ 'mt-4': !selectedCity, 'mt-0': selectedCity }"
  >
    <button
      class="bg-black text-white px-4 xl:px-6 py-3 rounded-md fs-condensed flex items-center justify-center gap-2 text-xs xl:text-sm w-max"
      (click)="selectedCity = cities[0].id"
      aria-label="Ver todas las sucursales"
      title="Ver todas las sucursales"
    >
      <img
        src="/allas-icons/sucursal.svg"
        alt="Icono de sucursal"
        class="size-4"
      />
      <span aria-hidden="true">VER TODAS LAS SUCURSALES</span>
    </button>
    <h4 class="text-sm font-medium text-appBlack fs-condensed mt-2">
      ENCUENTRA TU TIENDA POR CIUDAD
    </h4>
    <div class="flex flex-col gap-2">
      @for (city of cities; track city) {
      <!---->
      @if(city.id !== 'TODAS') {
      <article
        class="flex gap-2 items-center justify-between fs-condensed cursor-pointer hover:text-allasRed transition-colors duration-150 ease-in-out"
        (click)="selectedCity = city.id"
      >
        <span>
          {{ city.name }}
        </span>
        <span>
          (
          {{ city.stores.length }}
          )
        </span>
      </article>
      }
      <!---->
      }
    </div>
  </div>
</ng-template>

<!-- Store List -->
<ng-template #storeList>
  <span
    class="text-sm font-medium text-appBlack fs-condensed mb-2 underline cursor-pointer ml-4 xl:ml-0"
    (click)="selectedCity = null"
  >
    Cambiar ciudad
  </span>
  <div
    class="flex-1 overflow-y-auto mt-4"
    role="list"
    aria-label="Lista de sucursales disponibles"
  >
    @for (store of filteredStores; track store.id) {
    <article
      class="p-4 flex flex-col gap-3 items-center px-6 border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150 ease-in-out w-full xl:min-w-[30rem]"
      [class.bg-gray-200]="storeService.getSelectedStore()?.id === store.id"
      role="listitem"
      [attr.aria-label]="
        'Sucursal ' + store.name + ', ' + (store.isOpen ? 'abierta' : 'cerrada')
      "
    >
      <!-- Icono y Nombre -->
      <div class="flex flex-col gap-1 w-full">
        <div class="flex gap-2 items-center">
          <img
            src="/allas-icons/store-new-red.svg"
            alt="Icono de sucursal"
            class="size-5"
            width="20"
            height="20"
            loading="lazy"
          />
          <span class="fs-condensed font-bold" aria-hidden="true">
            ALLAS REPUESTOS, {{ store.name | uppercase }}
          </span>
        </div>
      </div>
      <!-- Estado y distancia -->
      <div class="flex gap-1 justify-between w-full px-6">
        <span
          [class]="getStatusClasses(store.isOpen)"
          [attr.aria-label]="'Estado: ' + getStatusText(store.isOpen)"
        >
          {{ getStatusText(store.isOpen) }}
        </span>
        <span
          class="text-sm font-medium fs-condensed -skew-x-6"
          [attr.aria-label]="
            store.distance
              ? 'Distancia: ' + formatDistance(store.distance || 0)
              : ''
          "
        >
          @if (store.distance) {
          {{ formatDistance(store.distance || 0) }}
          }
        </span>
      </div>
      <!-- Botones de Acción -->
      <div class="flex gap-2 w-full">
        <button
          class="bg-appPrimary-500 text-white px-2 py-2 rounded-md fs-condensed flex items-center justify-center gap-1 text-[10px] xl:text-xs w-1/3"
          (click)="handleStoreSelect(store)"
          [attr.aria-label]="
            storeService.getSelectedStore()?.id === store.id
              ? 'Sucursal ya seleccionada'
              : 'Seleccionar esta sucursal'
          "
          [attr.title]="
            storeService.getSelectedStore()?.id === store.id
              ? 'Sucursal ya seleccionada'
              : 'Seleccionar esta sucursal'
          "
        >
          @if (storeService.getSelectedStore()?.id === store.id) {
          <!---->
          <lucide-icon
            [img]="checkIcon"
            class="size-3"
            aria-hidden="true"
          ></lucide-icon>
          <span aria-hidden="true">SELECCIONADA</span>
          <!---->
          } @else {
          <!---->
          <span aria-hidden="true">SELECCIONAR</span>
          <!---->
          }
        </button>
        <!-- Navegar Button (for Desktop) -->
        <button
          class="hidden xl:flex w-1/3"
          (click)="
            selectedStoreForNavigation = store; navigationPopover.toggle($event)
          "
          aria-label="Abrir opciones de navegación para esta sucursal"
          title="Abrir opciones de navegación"
        >
          <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
        </button>
        <!-- Navegar Button (for Mobile) -->
        <button
          class="xl:hidden w-1/3"
          (click)="openNavigation(store)"
          aria-label="Abrir opciones de navegación para esta sucursal"
          title="Abrir opciones de navegación"
        >
          <ng-container *ngTemplateOutlet="navegarButton"></ng-container>
        </button>
        <button
          class="border border-gray-500 px-2 py-2 rounded-md fs-condensed flex items-center justify-center gap-2 text-[10px] xl:text-xs w-1/3"
          (click)="handleStoreClick(store)"
          aria-label="Ver más detalles de la sucursal"
          title="Ver más detalles"
        >
          <span aria-hidden="true">MÁS DETALLES</span>
        </button>
      </div>
    </article>
    }
  </div>
</ng-template>

<!-- Navigation Modal (for Mobile) -->
<p-drawer
  [(visible)]="navigationModalVisible"
  header="Escoger mapa"
  styleClass="fs-condensed"
  position="bottom"
  [style]="{ height: 'auto' }"
  aria-label="Modal de opciones de navegación"
>
  <ng-container *ngTemplateOutlet="navigationModal"></ng-container>
</p-drawer>

<!-- Navigation Modal (for Desktop) -->
<p-popover #navigationPopover aria-label="Opciones de navegación">
  <ng-container *ngTemplateOutlet="navigationModal"></ng-container>
</p-popover>

<ng-template #navigationModal>
  @if (selectedStoreForNavigation) {
  <div class="space-y-3">
    <button
      (click)="openInMaps(selectedStoreForNavigation)"
      class="w-full py-2 px-4 bg-appPrimary-500 text-white rounded-md flex gap-2 items-center justify-center fs-condensed"
      aria-label="Abrir ubicación en Google Maps"
      title="Abrir en Google Maps"
    >
      <lucide-icon
        [name]="mapPinIcon"
        class="size-4"
        aria-hidden="true"
      ></lucide-icon>
      <span aria-hidden="true">Google Maps</span>
    </button>

    <button
      (click)="openInWaze(selectedStoreForNavigation)"
      class="w-full py-2 px-4 bg-allasRed text-white rounded-md flex gap-2 items-center justify-center fs-condensed"
      aria-label="Abrir ubicación en Waze"
      title="Abrir en Waze"
    >
      <lucide-icon
        [name]="navigationIcon"
        class="size-4"
        aria-hidden="true"
      ></lucide-icon>
      <span aria-hidden="true">Waze</span>
    </button>
  </div>
  }
</ng-template>
